/**
 * A null object for error from react-hook-form.
 * @constant
 * @name emptyError
 */
export const emptyError = () => ({
  type: 'noType',
  message: ''
})
